// Static demo dataset for platform walkthrough
// This data is the same for all users and is never persisted to the database.
// All IDs are deterministic so cross-references work consistently.

export const DEMO_COMPANY_ID = 'demo-company-00000000-0000-0000-0000-000000000001'
export const DEMO_USER_ID = 'demo-user-00000000-0000-0000-0000-000000000001'

// ---------- Clients ----------
const clients = [
  {
    id: 'demo-client-001',
    company_id: DEMO_COMPANY_ID,
    name: 'Sarah Johnson',
    email: 'sarah.johnson@example.com',
    phone: '(555) 234-5678',
    address: '142 Maple Drive',
    city: 'Austin',
    state: 'TX',
    zip: '78701',
    source: 'Google',
    company_name: null,
    automation_enabled: true,
    notes: 'Prefers morning appointments. Two-story home with vinyl siding and a large back patio.',
    created_at: '2026-01-15T10:00:00.000Z',
    updated_at: '2026-01-15T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-client-002',
    company_id: DEMO_COMPANY_ID,
    name: "Mike's Auto Shop",
    email: 'mike@mikesautoshop.com',
    phone: '(555) 876-5432',
    address: '890 Commerce Blvd',
    city: 'Austin',
    state: 'TX',
    zip: '78702',
    source: 'Referral',
    company_name: "Mike's Auto Shop",
    automation_enabled: true,
    notes: 'Commercial property. Concrete lot and building exterior need quarterly cleaning.',
    created_at: '2026-01-18T14:30:00.000Z',
    updated_at: '2026-01-18T14:30:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-client-003',
    company_id: DEMO_COMPANY_ID,
    name: 'Garcia Family',
    email: 'maria.garcia@example.com',
    phone: '(555) 345-6789',
    address: '567 Oak Lane',
    city: 'Austin',
    state: 'TX',
    zip: '78703',
    source: 'Website',
    company_name: null,
    automation_enabled: true,
    notes: 'Completed full house wash and gutter cleaning last month. Very satisfied customer.',
    created_at: '2025-12-20T09:00:00.000Z',
    updated_at: '2026-01-28T16:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-client-004',
    company_id: DEMO_COMPANY_ID,
    name: 'Eastside Office Park',
    email: 'facilities@eastsideoffice.com',
    phone: '(555) 987-6543',
    address: '2100 Business Park Dr',
    city: 'Austin',
    state: 'TX',
    zip: '78704',
    source: 'Cold Call',
    company_name: 'Eastside Office Park LLC',
    automation_enabled: true,
    notes: 'Large commercial property. Building exterior and sidewalks need regular cleaning.',
    created_at: '2026-01-22T11:00:00.000Z',
    updated_at: '2026-01-22T11:00:00.000Z',
    created_by: DEMO_USER_ID
  }
]

// ---------- Services ----------
const services = [
  {
    id: 'demo-service-001',
    company_id: DEMO_COMPANY_ID,
    name: 'House Wash (Soft Wash)',
    description: 'Low-pressure soft wash for siding, stucco, and painted surfaces. Removes mold, mildew, algae, and dirt safely.',
    price: 350,
    price_type: 'component_based',
    pricing_components: [
      { price_type: 'fixed', price: '350.00', unit_label: 'flat rate', description: 'Standard residential house wash (up to 2,500 sq ft)', calculation_basis: 'subtotal', is_required: true }
    ],
    service_category_id: 'demo-category-001',
    display_on_quote: true,
    is_taxable: true,
    is_active: true,
    tags: ['soft wash', 'house wash', 'exterior cleaning'],
    use_map_measurement: true,    use_custom_scheduling: true,
    custom_appointment_duration_minutes: 180,
    custom_grace_period_minutes: 30,
    created_at: '2026-01-10T08:00:00.000Z',
    updated_at: '2026-01-10T08:00:00.000Z'
  },
  {
    id: 'demo-service-002',
    company_id: DEMO_COMPANY_ID,
    name: 'Pressure Washing — Driveway & Concrete',
    description: 'High-pressure surface cleaning for driveways, sidewalks, patios, and other concrete/brick surfaces.',
    price: 0.15,
    price_type: 'component_based',
    pricing_components: [
      { price_type: 'sqft', price: '0.15', unit_label: 'per sq ft', description: 'Concrete surface cleaning', calculation_basis: 'subtotal', is_required: true }
    ],
    service_category_id: 'demo-category-002',
    display_on_quote: true,
    is_taxable: true,
    is_active: true,
    tags: ['pressure washing', 'driveway', 'concrete', 'flatwork'],
    use_map_measurement: true,    use_custom_scheduling: true,
    custom_appointment_duration_minutes: 120,
    custom_grace_period_minutes: 30,
    created_at: '2026-01-10T08:00:00.000Z',
    updated_at: '2026-01-10T08:00:00.000Z'
  },
  {
    id: 'demo-service-003',
    company_id: DEMO_COMPANY_ID,
    name: 'Gutter Cleaning',
    description: 'Full gutter cleanout including downspout flush and debris removal. Includes ground cleanup.',
    price: 150,
    price_type: 'component_based',
    pricing_components: [
      { price_type: 'fixed', price: '150.00', unit_label: 'flat rate', description: 'Standard home gutter cleaning (up to 200 linear ft)', calculation_basis: 'subtotal', is_required: true }
    ],
    service_category_id: 'demo-category-001',
    display_on_quote: true,
    is_taxable: true,
    is_active: true,
    tags: ['gutter', 'cleaning', 'maintenance'],
    use_map_measurement: false,    use_custom_scheduling: true,
    custom_appointment_duration_minutes: 90,
    custom_grace_period_minutes: 30,
    created_at: '2026-01-10T08:00:00.000Z',
    updated_at: '2026-01-10T08:00:00.000Z'
  },
  {
    id: 'demo-service-004',
    company_id: DEMO_COMPANY_ID,
    name: 'Roof Wash (Soft Wash)',
    description: 'Gentle soft wash treatment for asphalt shingle, tile, or metal roofs. Kills and removes black streaks, algae, and moss.',
    price: 450,
    price_type: 'component_based',
    pricing_components: [
      { price_type: 'fixed', price: '450.00', unit_label: 'flat rate', description: 'Standard residential roof wash (up to 2,000 sq ft)', calculation_basis: 'subtotal', is_required: true }
    ],
    service_category_id: 'demo-category-001',
    display_on_quote: true,
    is_taxable: true,
    is_active: true,
    tags: ['roof wash', 'soft wash', 'algae removal'],
    use_map_measurement: true,    use_custom_scheduling: true,
    custom_appointment_duration_minutes: 150,
    custom_grace_period_minutes: 30,
    created_at: '2026-01-10T08:00:00.000Z',
    updated_at: '2026-01-10T08:00:00.000Z'
  },
  {
    id: 'demo-service-005',
    company_id: DEMO_COMPANY_ID,
    name: 'Window Cleaning (Exterior)',
    description: 'Professional exterior window cleaning using water-fed pole or traditional squeegee method.',
    price: 8,
    price_type: 'component_based',
    pricing_components: [
      { price_type: 'fixed', price: '8.00', unit_label: 'per pane', description: 'Exterior window pane cleaning', calculation_basis: 'subtotal', is_required: true }
    ],
    service_category_id: 'demo-category-003',
    display_on_quote: true,
    is_taxable: true,
    is_active: true,
    tags: ['window cleaning', 'exterior', 'glass'],
    use_map_measurement: false,    use_custom_scheduling: false,
    custom_appointment_duration_minutes: null,
    custom_grace_period_minutes: null,
    created_at: '2026-01-10T08:00:00.000Z',
    updated_at: '2026-01-10T08:00:00.000Z'
  }
]

// ---------- Service Categories ----------
const service_categories = [
  {
    id: 'demo-category-001',
    company_id: DEMO_COMPANY_ID,
    name: 'Soft Washing',
    description: 'Low-pressure exterior cleaning services',
    display_order: 1,
    is_active: true,
    created_at: '2026-01-10T08:00:00.000Z'
  },
  {
    id: 'demo-category-002',
    company_id: DEMO_COMPANY_ID,
    name: 'Pressure Washing',
    description: 'High-pressure surface cleaning services',
    display_order: 2,
    is_active: true,
    created_at: '2026-01-10T08:00:00.000Z'
  },
  {
    id: 'demo-category-003',
    company_id: DEMO_COMPANY_ID,
    name: 'Window & Detail',
    description: 'Window cleaning and detail work',
    display_order: 3,
    is_active: true,
    created_at: '2026-01-10T08:00:00.000Z'
  }
]

// ---------- Helper: relative dates ----------
const daysFromNow = (days) => {
  const d = new Date()
  d.setDate(d.getDate() + days)
  d.setHours(9, 0, 0, 0)
  return d.toISOString()
}

const daysAgo = (days) => {
  const d = new Date()
  d.setDate(d.getDate() - days)
  d.setHours(9, 0, 0, 0)
  return d.toISOString()
}

// Today helper — returns an ISO string for today at a specific hour
const todayAt = (hour, minute = 0) => {
  const d = new Date()
  d.setHours(hour, minute, 0, 0)
  return d.toISOString()
}

// ---------- Estimates ----------
const estimates = [
  {
    id: 'demo-estimate-001',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-001',
    job_id: 'demo-job-001',
    estimate_number: 'EST-2026-001',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: 'Sarah Johnson',
    customer_email: 'sarah.johnson@example.com',
    customer_phone: '(555) 234-5678',
    customer_address: '142 Maple Drive, Austin, TX 78701',
    items: JSON.stringify([
      { description: 'House Wash (Soft Wash)', quantity: 1, price: 350, unitPrice: 350, name: 'House Wash (Soft Wash)' },
      { description: 'Gutter Cleaning', quantity: 1, price: 150, unitPrice: 150, name: 'Gutter Cleaning' }
    ]),
    subtotal: 500,
    discount_amount: 50,
    discount_type: 'fixed',
    deposit_amount: 100,
    tax_amount: 0,
    final_price: 450,
    notes: 'Full house wash and gutter cleanout. $50 bundle discount applied.',
    created_at: '2026-01-20T10:00:00.000Z',
    updated_at: '2026-01-22T14:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-002',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-002',
    job_id: 'demo-job-004',
    estimate_number: 'EST-2026-002',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: "Mike's Auto Shop",
    customer_email: 'mike@mikesautoshop.com',
    customer_phone: '(555) 876-5432',
    customer_address: '890 Commerce Blvd, Austin, TX 78702',
    items: JSON.stringify([
      { description: 'Pressure Washing — Driveway & Concrete (3,000 sq ft)', quantity: 3000, price: 0.15, unitPrice: 0.15, name: 'Pressure Washing — Driveway & Concrete' },
      { description: 'Window Cleaning (Exterior) — 24 panes', quantity: 24, price: 8, unitPrice: 8, name: 'Window Cleaning (Exterior)' }
    ]),
    subtotal: 642,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_amount: 0,
    final_price: 642,
    notes: 'Quarterly exterior cleaning for commercial lot and storefront windows.',
    created_at: '2025-11-05T09:00:00.000Z',
    updated_at: '2025-11-06T09:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-003',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-004',
    job_id: 'demo-job-005',
    estimate_number: 'EST-2026-003',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: 'Eastside Office Park',
    customer_email: 'facilities@eastsideoffice.com',
    customer_phone: '(555) 987-6543',
    customer_address: '2100 Business Park Dr, Austin, TX 78704',
    items: JSON.stringify([
      { description: 'House Wash (Soft Wash) — Building Exterior', quantity: 1, price: 1200, unitPrice: 1200, name: 'House Wash (Soft Wash)' },
      { description: 'Pressure Washing — Sidewalks & Parking (5,000 sq ft)', quantity: 5000, price: 0.15, unitPrice: 0.15, name: 'Pressure Washing — Driveway & Concrete' }
    ]),
    subtotal: 1950,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 400,
    tax_amount: 0,
    final_price: 1950,
    notes: 'Full building exterior wash and parking lot/sidewalk pressure wash.',
    created_at: '2025-10-15T11:00:00.000Z',
    updated_at: '2025-10-16T15:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-004',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-003',
    job_id: 'demo-job-002',
    estimate_number: 'EST-2025-004',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: 'Garcia Family',
    customer_email: 'maria.garcia@example.com',
    customer_phone: '(555) 345-6789',
    customer_address: '567 Oak Lane, Austin, TX 78703',
    items: JSON.stringify([
      { description: 'House Wash (Soft Wash)', quantity: 1, price: 350, unitPrice: 350, name: 'House Wash (Soft Wash)' },
      { description: 'Gutter Cleaning', quantity: 1, price: 150, unitPrice: 150, name: 'Gutter Cleaning' }
    ]),
    subtotal: 500,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_amount: 0,
    final_price: 500,
    notes: 'House wash and gutter cleaning.',
    created_at: '2025-08-10T09:00:00.000Z',
    updated_at: '2025-08-11T09:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-005',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-003',
    job_id: 'demo-job-006',
    estimate_number: 'EST-2025-005',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: 'Garcia Family',
    customer_email: 'maria.garcia@example.com',
    customer_phone: '(555) 345-6789',
    customer_address: '567 Oak Lane, Austin, TX 78703',
    items: JSON.stringify([
      { description: 'Roof Wash (Soft Wash)', quantity: 1, price: 450, unitPrice: 450, name: 'Roof Wash (Soft Wash)' },
      { description: 'Gutter Cleaning', quantity: 1, price: 150, unitPrice: 150, name: 'Gutter Cleaning' }
    ]),
    subtotal: 600,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_amount: 0,
    final_price: 600,
    notes: 'Return visit for roof wash and gutter cleaning.',
    created_at: '2025-12-05T09:00:00.000Z',
    updated_at: '2025-12-06T09:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-006',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-001',
    job_id: 'demo-job-007',
    estimate_number: 'EST-2025-006',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: 'Sarah Johnson',
    customer_email: 'sarah.johnson@example.com',
    customer_phone: '(555) 234-5678',
    customer_address: '142 Maple Drive, Austin, TX 78701',
    items: JSON.stringify([
      { description: 'Pressure Washing — Driveway & Concrete (1,500 sq ft)', quantity: 1500, price: 0.15, unitPrice: 0.15, name: 'Pressure Washing — Driveway & Concrete' },
      { description: 'Deck & Fence Cleaning', quantity: 1, price: 275, unitPrice: 275, name: 'Deck & Fence Cleaning' }
    ]),
    subtotal: 500,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_amount: 0,
    final_price: 500,
    notes: 'Driveway pressure wash and deck cleaning.',
    created_at: '2025-06-15T09:00:00.000Z',
    updated_at: '2025-06-16T09:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-007',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-002',
    job_id: 'demo-job-008',
    estimate_number: 'EST-2026-007',
    estimate_type: 'standard',
    status: 'accepted',
    customer_name: "Mike's Auto Shop",
    customer_email: 'mike@mikesautoshop.com',
    customer_phone: '(555) 876-5432',
    customer_address: '890 Commerce Blvd, Austin, TX 78702',
    items: JSON.stringify([
      { description: 'Pressure Washing — Driveway & Concrete (3,000 sq ft)', quantity: 3000, price: 0.15, unitPrice: 0.15, name: 'Pressure Washing — Driveway & Concrete' },
      { description: 'Window Cleaning (Exterior) — 24 panes', quantity: 24, price: 8, unitPrice: 8, name: 'Window Cleaning (Exterior)' }
    ]),
    subtotal: 642,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_amount: 0,
    final_price: 642,
    notes: 'Q1 2026 quarterly exterior cleaning.',
    created_at: '2026-02-10T09:00:00.000Z',
    updated_at: '2026-02-10T09:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-estimate-008',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-004',
    job_id: null,
    estimate_number: 'EST-2026-008',
    estimate_type: 'standard',
    status: 'sent',
    customer_name: 'Eastside Office Park',
    customer_email: 'facilities@eastsideoffice.com',
    customer_phone: '(555) 987-6543',
    customer_address: '2100 Business Park Dr, Austin, TX 78704',
    items: JSON.stringify([
      { description: 'Roof Wash (Soft Wash) — Commercial Building', quantity: 1, price: 2800, unitPrice: 2800, name: 'Roof Wash (Soft Wash)' }
    ]),
    subtotal: 2800,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_amount: 0,
    final_price: 2800,
    notes: 'Annual roof wash for office park building.',
    created_at: '2026-02-18T11:00:00.000Z',
    updated_at: '2026-02-18T11:00:00.000Z',
    created_by: DEMO_USER_ID
  }
]

// ---------- Jobs ----------
const jobs = [
  {
    id: 'demo-job-001',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-001',
    estimate_id: 'demo-estimate-001',
    title: 'Job for Sarah Johnson — House Wash & Gutters',
    description: 'House wash and gutter cleaning at 142 Maple Drive',
    status: 'scheduled',
    priority: 'medium',
    scheduled_at: daysFromNow(1),
    created_at: '2026-01-22T14:00:00.000Z',
    updated_at: '2026-01-22T14:00:00.000Z'
  },
  {
    id: 'demo-job-002',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-003',
    estimate_id: 'demo-estimate-004',
    title: 'Job for Garcia Family — House Wash & Gutters',
    description: 'Full house wash and gutter cleaning — completed successfully',
    status: 'completed',
    priority: 'high',
    scheduled_at: '2025-08-15T09:00:00.000Z',
    completed_at: '2025-08-15T14:00:00.000Z',
    created_at: '2025-08-11T09:00:00.000Z',
    updated_at: '2025-08-15T14:00:00.000Z'
  },
  {
    id: 'demo-job-003',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-004',
    estimate_id: null,
    title: 'Job for Eastside Office Park — Pressure Wash',
    description: 'Pressure washing sidewalks and building entrance',
    status: 'in_progress',
    priority: 'medium',
    scheduled_at: todayAt(9),
    created_at: daysAgo(3),
    updated_at: todayAt(9)
  },
  // Additional completed jobs for repeat client metrics & seasonal spread
  {
    id: 'demo-job-004',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-002',
    estimate_id: 'demo-estimate-002',
    title: "Job for Mike's Auto Shop — Q4 Cleaning",
    description: 'Quarterly pressure wash and window cleaning',
    status: 'completed',
    priority: 'medium',
    scheduled_at: '2025-11-10T09:00:00.000Z',
    completed_at: '2025-11-10T15:00:00.000Z',
    created_at: '2025-11-06T09:00:00.000Z',
    updated_at: '2025-11-10T15:00:00.000Z'
  },
  {
    id: 'demo-job-005',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-004',
    estimate_id: 'demo-estimate-003',
    title: 'Job for Eastside Office Park — Building Wash',
    description: 'Full building exterior wash and parking lot pressure wash',
    status: 'completed',
    priority: 'high',
    scheduled_at: '2025-10-20T08:00:00.000Z',
    completed_at: '2025-10-20T16:00:00.000Z',
    created_at: '2025-10-16T15:00:00.000Z',
    updated_at: '2025-10-20T16:00:00.000Z'
  },
  {
    id: 'demo-job-006',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-003',
    estimate_id: 'demo-estimate-005',
    title: 'Job for Garcia Family — Roof Wash',
    description: 'Return visit: roof wash and gutter cleaning',
    status: 'completed',
    priority: 'medium',
    scheduled_at: '2025-12-10T09:00:00.000Z',
    completed_at: '2025-12-10T14:00:00.000Z',
    created_at: '2025-12-06T09:00:00.000Z',
    updated_at: '2025-12-10T14:00:00.000Z'
  },
  {
    id: 'demo-job-007',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-001',
    estimate_id: 'demo-estimate-006',
    title: 'Job for Sarah Johnson — Driveway & Deck',
    description: 'Driveway pressure wash and deck cleaning',
    status: 'completed',
    priority: 'low',
    scheduled_at: '2025-06-20T09:00:00.000Z',
    completed_at: '2025-06-20T13:00:00.000Z',
    created_at: '2025-06-16T09:00:00.000Z',
    updated_at: '2025-06-20T13:00:00.000Z'
  },
  {
    id: 'demo-job-008',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-002',
    estimate_id: 'demo-estimate-007',
    title: "Job for Mike's Auto Shop — Q1 2026 Cleaning",
    description: 'Quarterly pressure wash and window cleaning',
    status: 'completed',
    priority: 'medium',
    scheduled_at: '2026-02-12T09:00:00.000Z',
    completed_at: '2026-02-12T15:00:00.000Z',
    created_at: '2026-02-10T09:00:00.000Z',
    updated_at: '2026-02-12T15:00:00.000Z'
  }
]

// ---------- Invoices ----------
const invoices = [
  {
    id: 'demo-invoice-001',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-003',
    job_id: 'demo-job-002',
    estimate_id: 'demo-estimate-004',
    invoice_number: 'INV-2025-001',
    status: 'paid',
    items: JSON.stringify([
      { description: 'House Wash (Soft Wash)', quantity: 1, unitPrice: 350, price: 350 },
      { description: 'Gutter Cleaning', quantity: 1, unitPrice: 150, price: 150 }
    ]),
    subtotal: 500,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_rate: 8.25,
    tax_amount: 41.25,
    total_amount: 541.25,
    final_price: 541.25,
    notes: 'Thank you for your business!',
    due_date: '2025-08-30T00:00:00.000Z',
    paid_at: '2025-08-22T10:00:00.000Z',
    created_at: '2025-08-16T09:00:00.000Z',
    updated_at: '2025-08-22T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-invoice-002',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-001',
    job_id: 'demo-job-001',
    estimate_id: 'demo-estimate-001',
    invoice_number: 'INV-2026-002',
    status: 'draft',
    items: JSON.stringify([
      { description: 'House Wash (Soft Wash)', quantity: 1, unitPrice: 350, price: 350 },
      { description: 'Gutter Cleaning', quantity: 1, unitPrice: 150, price: 150 }
    ]),
    subtotal: 500,
    discount_amount: 50,
    discount_type: 'fixed',
    deposit_amount: 100,
    tax_rate: 0,
    tax_amount: 0,
    total_amount: 450,
    final_price: 450,
    notes: 'Deposit of $100 already received.',
    due_date: daysFromNow(14),
    paid_at: null,
    created_at: '2026-02-01T10:00:00.000Z',
    updated_at: '2026-02-01T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-invoice-003',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-001',
    job_id: 'demo-job-007',
    estimate_id: 'demo-estimate-006',
    invoice_number: 'INV-2025-003',
    status: 'paid',
    items: JSON.stringify([
      { description: 'Pressure Washing — Driveway & Concrete (1,500 sq ft)', quantity: 1500, unitPrice: 0.15, price: 225 },
      { description: 'Deck & Fence Cleaning', quantity: 1, unitPrice: 275, price: 275 }
    ]),
    subtotal: 500,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_rate: 8.25,
    tax_amount: 41.25,
    total_amount: 541.25,
    final_price: 541.25,
    notes: 'Driveway and deck cleaning completed.',
    due_date: '2025-07-05T00:00:00.000Z',
    paid_at: '2025-06-28T10:00:00.000Z',
    created_at: '2025-06-21T09:00:00.000Z',
    updated_at: '2025-06-28T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-invoice-004',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-002',
    job_id: 'demo-job-004',
    estimate_id: 'demo-estimate-002',
    invoice_number: 'INV-2025-004',
    status: 'paid',
    items: JSON.stringify([
      { description: 'Pressure Washing — Driveway & Concrete (3,000 sq ft)', quantity: 3000, unitPrice: 0.15, price: 450 },
      { description: 'Window Cleaning (Exterior) — 24 panes', quantity: 24, unitPrice: 8, price: 192 }
    ]),
    subtotal: 642,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_rate: 8.25,
    tax_amount: 52.97,
    total_amount: 694.97,
    final_price: 694.97,
    notes: 'Q4 quarterly cleaning completed.',
    due_date: '2025-11-25T00:00:00.000Z',
    paid_at: '2025-11-18T10:00:00.000Z',
    created_at: '2025-11-11T09:00:00.000Z',
    updated_at: '2025-11-18T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-invoice-005',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-004',
    job_id: 'demo-job-005',
    estimate_id: 'demo-estimate-003',
    invoice_number: 'INV-2025-005',
    status: 'paid',
    items: JSON.stringify([
      { description: 'House Wash (Soft Wash) — Building Exterior', quantity: 1, unitPrice: 1200, price: 1200 },
      { description: 'Pressure Washing — Sidewalks & Parking (5,000 sq ft)', quantity: 5000, unitPrice: 0.15, price: 750 }
    ]),
    subtotal: 1950,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 400,
    tax_rate: 8.25,
    tax_amount: 160.88,
    total_amount: 2110.88,
    final_price: 2110.88,
    notes: 'Building wash and parking lot pressure wash.',
    due_date: '2025-11-05T00:00:00.000Z',
    paid_at: '2025-10-30T10:00:00.000Z',
    created_at: '2025-10-21T09:00:00.000Z',
    updated_at: '2025-10-30T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-invoice-006',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-003',
    job_id: 'demo-job-006',
    estimate_id: 'demo-estimate-005',
    invoice_number: 'INV-2025-006',
    status: 'paid',
    items: JSON.stringify([
      { description: 'Roof Wash (Soft Wash)', quantity: 1, unitPrice: 450, price: 450 },
      { description: 'Gutter Cleaning', quantity: 1, unitPrice: 150, price: 150 }
    ]),
    subtotal: 600,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_rate: 8.25,
    tax_amount: 49.50,
    total_amount: 649.50,
    final_price: 649.50,
    notes: 'Roof wash and gutter cleaning — repeat customer.',
    due_date: '2025-12-25T00:00:00.000Z',
    paid_at: '2025-12-18T10:00:00.000Z',
    created_at: '2025-12-11T09:00:00.000Z',
    updated_at: '2025-12-18T10:00:00.000Z',
    created_by: DEMO_USER_ID
  },
  {
    id: 'demo-invoice-007',
    company_id: DEMO_COMPANY_ID,
    client_id: 'demo-client-002',
    job_id: 'demo-job-008',
    estimate_id: 'demo-estimate-007',
    invoice_number: 'INV-2026-007',
    status: 'sent',
    items: JSON.stringify([
      { description: 'Pressure Washing — Driveway & Concrete (3,000 sq ft)', quantity: 3000, unitPrice: 0.15, price: 450 },
      { description: 'Window Cleaning (Exterior) — 24 panes', quantity: 24, unitPrice: 8, price: 192 }
    ]),
    subtotal: 642,
    discount_amount: 0,
    discount_type: 'fixed',
    deposit_amount: 0,
    tax_rate: 0,
    tax_amount: 0,
    total_amount: 642,
    final_price: 642,
    notes: 'Q1 2026 quarterly cleaning.',
    due_date: daysFromNow(7),
    paid_at: null,
    created_at: '2026-02-13T09:00:00.000Z',
    updated_at: '2026-02-13T09:00:00.000Z',
    created_by: DEMO_USER_ID
  }
]

// ---------- Automations ----------
const automations = [
  {
    id: 'demo-automation-001',
    company_id: DEMO_COMPANY_ID,
    name: 'Follow-up after estimate sent',
    trigger_type: 'estimate_sent',
    trigger_config: {},
    status: 'active',
    category: 'sales',
    time_offset_minutes: 1440, // 24 hours
    time_offset_type: 'after',
    created_at: '2026-01-12T10:00:00.000Z',
    updated_at: '2026-01-12T10:00:00.000Z',
    actions: [
      {
        id: 'demo-action-001',
        automation_id: 'demo-automation-001',
        action_type: 'sms',
        action_config: {
          message: 'Hi {{client_name}}, just following up on the estimate we sent. Let us know if you have any questions!'
        },
        execution_order: 1
      }
    ]
  },
  {
    id: 'demo-automation-002',
    company_id: DEMO_COMPANY_ID,
    name: 'Thank you after job complete',
    trigger_type: 'job_completed',
    trigger_config: {},
    status: 'active',
    category: 'customer_service',
    time_offset_minutes: 0,
    time_offset_type: 'after',
    created_at: '2026-01-12T10:00:00.000Z',
    updated_at: '2026-01-12T10:00:00.000Z',
    actions: [
      {
        id: 'demo-action-002',
        automation_id: 'demo-automation-002',
        action_type: 'email',
        action_config: {
          subject: 'Thank you for choosing us!',
          body: 'Hi {{client_name}}, thank you for letting us take care of your property! We hope you love the results. If you need anything else, don\'t hesitate to reach out.'
        },
        execution_order: 1
      }
    ]
  }
]

// ---------- Calendar Events ----------
const calendar_events = [
  {
    id: 'demo-calendar-001',
    company_id: DEMO_COMPANY_ID,
    title: 'Sarah Johnson - House Wash & Gutters',
    description: 'House wash and gutter cleaning at 142 Maple Drive',
    start_time: daysFromNow(1),
    end_time: (() => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(13, 0, 0, 0); return d.toISOString() })(),
    event_type: 'job',
    related_job_id: 'demo-job-001',
    related_client_id: 'demo-client-001',
    created_at: '2026-01-22T14:00:00.000Z',
    updated_at: '2026-01-22T14:00:00.000Z'
  },
  {
    id: 'demo-calendar-002',
    company_id: DEMO_COMPANY_ID,
    title: 'Eastside Office Park - Pressure Wash',
    description: 'Pressure washing sidewalks and building entrance at 2100 Business Park Dr',
    start_time: todayAt(9),
    end_time: todayAt(13),
    event_type: 'job',
    related_job_id: 'demo-job-003',
    related_client_id: 'demo-client-004',
    created_at: daysAgo(3),
    updated_at: todayAt(9)
  }
]

// ---------- Payments ----------
const payments = [
  {
    id: 'demo-payment-001',
    company_id: DEMO_COMPANY_ID,
    invoice_id: 'demo-invoice-001',
    client_id: 'demo-client-003',
    amount: 500,
    status: 'completed',
    payment_method: 'card',
    payment_date: '2025-08-22T10:00:00.000Z',
    created_at: '2025-08-22T10:00:00.000Z',
    updated_at: '2025-08-22T10:00:00.000Z'
  },
  {
    id: 'demo-payment-002',
    company_id: DEMO_COMPANY_ID,
    invoice_id: 'demo-invoice-003',
    client_id: 'demo-client-001',
    amount: 500,
    status: 'completed',
    payment_method: 'card',
    payment_date: '2025-06-28T10:00:00.000Z',
    created_at: '2025-06-28T10:00:00.000Z',
    updated_at: '2025-06-28T10:00:00.000Z'
  },
  {
    id: 'demo-payment-003',
    company_id: DEMO_COMPANY_ID,
    invoice_id: 'demo-invoice-004',
    client_id: 'demo-client-002',
    amount: 642,
    status: 'completed',
    payment_method: 'check',
    payment_date: '2025-11-18T10:00:00.000Z',
    created_at: '2025-11-18T10:00:00.000Z',
    updated_at: '2025-11-18T10:00:00.000Z'
  },
  {
    id: 'demo-payment-004',
    company_id: DEMO_COMPANY_ID,
    invoice_id: 'demo-invoice-005',
    client_id: 'demo-client-004',
    amount: 1950,
    status: 'completed',
    payment_method: 'card',
    payment_date: '2025-10-30T10:00:00.000Z',
    created_at: '2025-10-30T10:00:00.000Z',
    updated_at: '2025-10-30T10:00:00.000Z'
  },
  {
    id: 'demo-payment-005',
    company_id: DEMO_COMPANY_ID,
    invoice_id: 'demo-invoice-006',
    client_id: 'demo-client-003',
    amount: 600,
    status: 'completed',
    payment_method: 'card',
    payment_date: '2025-12-18T10:00:00.000Z',
    created_at: '2025-12-18T10:00:00.000Z',
    updated_at: '2025-12-18T10:00:00.000Z'
  }
]

// ---------- Employees ----------
const employees = [
  {
    id: 'demo-employee-001',
    company_id: DEMO_COMPANY_ID,
    user_id: DEMO_USER_ID,
    name: 'You (Owner)',
    email: 'owner@demo.com',
    role: 'owner',
    status: 'active',
    created_at: '2026-01-10T08:00:00.000Z',
    updated_at: '2026-01-10T08:00:00.000Z'
  }
]

// ---------- Expense Categories (Schedule C aligned) ----------
const expense_categories = [
  { id: 'demo-expcat-001', company_id: DEMO_COMPANY_ID, name: 'Advertising & Marketing', type: 'OVERHEAD', schedule_c_line: '8', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-002', company_id: DEMO_COMPANY_ID, name: 'Car & Truck Expenses', type: 'OVERHEAD', schedule_c_line: '9', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-003', company_id: DEMO_COMPANY_ID, name: 'Subcontractors', type: 'OVERHEAD', schedule_c_line: '11', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-004', company_id: DEMO_COMPANY_ID, name: 'Depreciation (Equipment)', type: 'OVERHEAD', schedule_c_line: '13', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-005', company_id: DEMO_COMPANY_ID, name: 'Insurance', type: 'OVERHEAD', schedule_c_line: '15', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-006', company_id: DEMO_COMPANY_ID, name: 'Interest', type: 'OVERHEAD', schedule_c_line: '16', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-007', company_id: DEMO_COMPANY_ID, name: 'Legal & Professional Services', type: 'OVERHEAD', schedule_c_line: '17', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-008', company_id: DEMO_COMPANY_ID, name: 'Office Expenses', type: 'OVERHEAD', schedule_c_line: '18', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-009', company_id: DEMO_COMPANY_ID, name: 'Rent / Lease', type: 'OVERHEAD', schedule_c_line: '20', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-010', company_id: DEMO_COMPANY_ID, name: 'Repairs & Maintenance', type: 'COGS', schedule_c_line: '21', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-011', company_id: DEMO_COMPANY_ID, name: 'Supplies', type: 'COGS', schedule_c_line: '22', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-012', company_id: DEMO_COMPANY_ID, name: 'Taxes & Licenses', type: 'OVERHEAD', schedule_c_line: '23', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-013', company_id: DEMO_COMPANY_ID, name: 'Travel', type: 'OVERHEAD', schedule_c_line: '24a', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-014', company_id: DEMO_COMPANY_ID, name: 'Meals (50% Deductible)', type: 'OVERHEAD', schedule_c_line: '24b', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-015', company_id: DEMO_COMPANY_ID, name: 'Utilities', type: 'OVERHEAD', schedule_c_line: '25', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' },
  { id: 'demo-expcat-016', company_id: DEMO_COMPANY_ID, name: 'Other Expenses', type: 'OVERHEAD', schedule_c_line: '27', is_system: true, parent_id: null, created_at: '2026-01-10T08:00:00.000Z', updated_at: '2026-01-10T08:00:00.000Z' }
]

// ---------- Expenses ----------
const expenses = [
  {
    id: 'demo-expense-001',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'SouthChem Supply Co.',
    expense_date: '2026-02-05',
    total_amount: 285.50,
    tax_amount: 0,
    currency: 'USD',
    category_id: 'demo-expcat-011',
    payment_method: 'card',
    notes: 'Soft wash chemicals — SH and surfactant',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-05T10:00:00.000Z',
    updated_at: '2026-02-05T10:00:00.000Z'
  },
  {
    id: 'demo-expense-002',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'Shell Gas Station',
    expense_date: '2026-02-10',
    total_amount: 87.40,
    tax_amount: 0,
    currency: 'USD',
    category_id: 'demo-expcat-002',
    payment_method: 'card',
    notes: 'Fuel for work truck',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-10T08:00:00.000Z',
    updated_at: '2026-02-10T08:00:00.000Z'
  },
  {
    id: 'demo-expense-003',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'State Farm Insurance',
    expense_date: '2026-01-15',
    total_amount: 425.00,
    tax_amount: 0,
    currency: 'USD',
    category_id: 'demo-expcat-005',
    payment_method: 'ach',
    notes: 'Monthly general liability insurance premium',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-01-15T09:00:00.000Z',
    updated_at: '2026-01-15T09:00:00.000Z'
  },
  {
    id: 'demo-expense-004',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'Home Depot',
    expense_date: '2026-02-12',
    total_amount: 156.80,
    tax_amount: 12.80,
    currency: 'USD',
    category_id: 'demo-expcat-011',
    payment_method: 'card',
    notes: 'Replacement spray nozzles and hose fittings',
    job_id: 'demo-job-008',
    is_billable: true,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-12T14:00:00.000Z',
    updated_at: '2026-02-12T14:00:00.000Z'
  },
  {
    id: 'demo-expense-005',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'Google Ads',
    expense_date: '2026-02-01',
    total_amount: 350.00,
    tax_amount: 0,
    currency: 'USD',
    category_id: 'demo-expcat-001',
    payment_method: 'card',
    notes: 'February Google Ads spend for local service ads',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-01T08:00:00.000Z',
    updated_at: '2026-02-01T08:00:00.000Z'
  },
  {
    id: 'demo-expense-006',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'Pressure Washer Depot',
    expense_date: '2025-11-20',
    total_amount: 189.99,
    tax_amount: 15.49,
    currency: 'USD',
    category_id: 'demo-expcat-010',
    payment_method: 'card',
    notes: 'Pump rebuild kit for 4000 PSI washer',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2025-11-20T10:00:00.000Z',
    updated_at: '2025-11-20T10:00:00.000Z'
  },
  {
    id: 'demo-expense-007',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'QuickBooks',
    expense_date: '2026-02-01',
    total_amount: 45.00,
    tax_amount: 0,
    currency: 'USD',
    category_id: 'demo-expcat-008',
    payment_method: 'card',
    notes: 'Monthly accounting software subscription',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-01T08:00:00.000Z',
    updated_at: '2026-02-01T08:00:00.000Z'
  },
  {
    id: 'demo-expense-008',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'AT&T',
    expense_date: '2026-02-15',
    total_amount: 135.00,
    tax_amount: 10.00,
    currency: 'USD',
    category_id: 'demo-expcat-015',
    payment_method: 'ach',
    notes: 'Business phone and internet bill',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-15T09:00:00.000Z',
    updated_at: '2026-02-15T09:00:00.000Z'
  },
  {
    id: 'demo-expense-009',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'City of Austin',
    expense_date: '2026-01-10',
    total_amount: 250.00,
    tax_amount: 0,
    currency: 'USD',
    category_id: 'demo-expcat-012',
    payment_method: 'check',
    notes: 'Annual business license renewal',
    job_id: null,
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-01-10T09:00:00.000Z',
    updated_at: '2026-01-10T09:00:00.000Z'
  },
  {
    id: 'demo-expense-010',
    company_id: DEMO_COMPANY_ID,
    created_by: DEMO_USER_ID,
    vendor: 'Chipotle',
    expense_date: '2026-02-12',
    total_amount: 24.50,
    tax_amount: 2.00,
    currency: 'USD',
    category_id: 'demo-expcat-014',
    payment_method: 'card',
    notes: 'Lunch during job at Eastside Office Park',
    job_id: 'demo-job-003',
    is_billable: false,
    is_reimbursable: false,
    status: 'posted',
    created_at: '2026-02-12T12:30:00.000Z',
    updated_at: '2026-02-12T12:30:00.000Z'
  }
]

// ---------- Company Branding (fallback) ----------
const company_branding = []

// ---------- Empty defaults for all other entities ----------
const emptyEntities = {
  packages: [],
  job_activity: [],
  job_checklists: [],
  job_checklist_items: [],
  job_media: [],
  job_checklist_attachments: [],
  recurring_expenses: [],
  expense_receipts: [],
  employee_permissions: [],
  messages: [],
  message_logs: [],
  email_logs: [],
  automation_templates: [],
  automation_executions: [],
  scheduled_automation_queue: [],
  magic_links: [],
  client_responses: [],
  ai_conversations: [],
  ai_messages: [],
  rag_documents: [],
  rag_chunks: [],
  files: [],
  tasks: [],
  vendors: [],
  user_dashboard_preferences: [],
  user_toolbelt_preferences: [],
  user_access_cache: [],
  audit_logs: [],
  webhook_events: [],
  job_financial_summary: [],
  job_costs_by_category: [],
  estimate_budget_by_category: [],
  job_checklist_complete: [],
  invoice_photos: [],
  companies: []
}

// Complete demo dataset - deep-cloned on access so each demo session gets a fresh copy
// Uses JSON round-trip instead of structuredClone for Hermes (React Native) compatibility
// Dynamic dates are patched at call time so "today" is always correct
export const getDemoData = () => {
  const data = JSON.parse(JSON.stringify({
    clients,
    services,
    service_categories,
    estimates,
    jobs,
    invoices,
    automations,
    calendar_events,
    payments,
    employees,
    expenses,
    expense_categories,
    company_branding,
    ...emptyEntities
  }))

  // Recompute dynamic dates relative to "now" so they never go stale
  const now = new Date()
  const makeDate = (dayOffset, hour = 9, minute = 0) => {
    const d = new Date(now)
    d.setDate(d.getDate() + dayOffset)
    d.setHours(hour, minute, 0, 0)
    return d.toISOString()
  }

  const today9 = makeDate(0, 9)
  const today13 = makeDate(0, 13)
  const tomorrow9 = makeDate(1, 9)
  const tomorrow13 = makeDate(1, 13)
  const threeDaysAgo9 = makeDate(-3, 9)
  const twoWeeksOut = makeDate(14)
  const oneWeekOut = makeDate(7)

  // Patch jobs with dynamic dates
  for (const job of data.jobs) {
    if (job.id === 'demo-job-001') {
      job.scheduled_at = tomorrow9
    } else if (job.id === 'demo-job-003') {
      job.scheduled_at = today9
      job.status = 'scheduled'
      job.created_at = threeDaysAgo9
      job.updated_at = today9
    }
  }

  // Patch calendar events with dynamic dates
  for (const event of data.calendar_events) {
    if (event.id === 'demo-calendar-001') {
      event.start_time = tomorrow9
      event.end_time = tomorrow13
    } else if (event.id === 'demo-calendar-002') {
      event.start_time = today9
      event.end_time = today13
      event.created_at = threeDaysAgo9
      event.updated_at = today9
    }
  }

  // Patch invoice due dates
  for (const inv of data.invoices) {
    if (inv.id === 'demo-invoice-002') {
      inv.due_date = twoWeeksOut
    } else if (inv.id === 'demo-invoice-007') {
      inv.due_date = oneWeekOut
    }
  }

  return data
}
